import React from "react";
import Menu from "../components/Menu";
import Layout from "./Layout.js";

export default function MenuView() {
  return (
    <Layout title="Menu">
      <Menu />
    </Layout>
    // <div className="pageWrapper">
    //   <Header title="Menu" />
    //   <div className="contentWrapper fadeInDelayed">
    //     <Menu />
    //   </div>
    //   <BottomNavBar />
    // </div>
  );
}
